import { UseChatHelpers } from '@ai-sdk/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { UIChatMessage } from '@/legacy/components/Chat/chat.types';

/**
 * A helper hook to start a conversation with the assistant.
 * It reads the query parameter from the Location's State and starts a conversation with the assistant if the messages are yet empty
 * ref: https://api.reactrouter.com/v7/interfaces/react_router.Location.html
 */
export function useConversationStarter(isLoading: boolean, chat?: UseChatHelpers<UIChatMessage>) {
  const { state } = useLocation();
  const { status, messages, sendMessage } = chat ?? {};

  useEffect(() => {
    // if we have a query and the chat is not loading, start a conversation
    if (
      !isLoading &&
      chat &&
      messages &&
      sendMessage &&
      messages.length === 0 &&
      status === 'ready' &&
      state?.initialMessage
    ) {
      sendMessage(
        {
          role: 'user',
          parts: [{ type: 'text', text: state.initialMessage }],
        },
        {
          body: { isConversationStarter: true },
        },
      );

      // clear the state by replacing current location without the initialMessage
      window.history.replaceState({}, '');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
}
